import * as i0 from '@angular/core';
import { Component, Input, ContentChildren, HostBinding, HostListener, NgModule } from '@angular/core';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class CarouselItemComponent {
}
CarouselItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: CarouselItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CarouselItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: CarouselItemComponent, selector: "sm-carousel-item", ngImport: i0, template: `
    <div class="item-container">
      <ng-content></ng-content>
    </div>
  `, isInline: true, styles: [":host{width:var(--carousel-width);height:var(--carousel-height);scroll-snap-align:center;position:relative;display:flex;align-items:center}.item-container{flex:1;height:100%}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: CarouselItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sm-carousel-item', template: `
    <div class="item-container">
      <ng-content></ng-content>
    </div>
  `, styles: [":host{width:var(--carousel-width);height:var(--carousel-height);scroll-snap-align:center;position:relative;display:flex;align-items:center}.item-container{flex:1;height:100%}\n"] }]
        }] });
class CarouselComponent {
    constructor(el) {
        this.el = el;
        this.hideNavigationButton = false;
        this.hideBullets = false;
        this._autoSlide = false;
        this._slideTImerInMS = 3000;
        this.numberOfSlides$ = new BehaviorSubject(0);
        this.currentSlideIndex$ = new BehaviorSubject(0);
        this.bulletArray$ = combineLatest([this.numberOfSlides$, this.currentSlideIndex$]).pipe(map(([numberOfSlides, currentSlideIndex]) => {
            return Array.from(Array(numberOfSlides)).map((v, i) => {
                return i === currentSlideIndex;
            });
        }));
        this.showPreviousButton$ = this.currentSlideIndex$.pipe(map((currentSlideIndex) => {
            if (this.hideNavigationButton) {
                return false;
            }
            if (currentSlideIndex === 0) {
                return false;
            }
            return true;
        }));
        this.showNextButton$ = combineLatest([this.currentSlideIndex$, this.numberOfSlides$]).pipe(map(([currentSlideIndex, numberOfSlides]) => {
            if (this.hideNavigationButton) {
                return false;
            }
            if (currentSlideIndex === numberOfSlides - 1) {
                return false;
            }
            return true;
        }));
        this.containerWidth$ = new BehaviorSubject(this.getContainerWidth());
    }
    set autoSlide(slide) {
        this._autoSlide = slide;
        this.queueNextAutoSlide();
    }
    get autoSlide() {
        return this._autoSlide;
    }
    set slideTimerInMs(slide) {
        this._slideTImerInMS = slide;
        this.queueNextAutoSlide();
    }
    get slideTimerInMs() {
        return this._slideTImerInMS;
    }
    setCurrentSlideIndex(index) {
        if (this.currentSlideIndex$.getValue() !== index) {
            this.currentSlideIndex$.next(index);
        }
    }
    onTouchDown() {
        clearTimeout(this.timer);
    }
    onTouchUp() {
        this.queueNextAutoSlide();
    }
    onScroll(evt) {
        const target = evt.currentTarget;
        const index = target.scrollLeft / this.containerWidth$.getValue();
        if ((index) % 1 == 0) {
            if (target.scrollLeft) {
                this.setCurrentSlideIndex(index);
            }
            else {
                this.setCurrentSlideIndex(0);
            }
        }
    }
    get carouselHeight() {
        return this.height;
    }
    slidePrevious() {
        this.slideToIndex(this.currentSlideIndex$.getValue() - 1);
    }
    slideNext() {
        this.slideToIndex(this.currentSlideIndex$.getValue() + 1);
    }
    slideToIndex(index) {
        if (index === this.currentSlideIndex$.getValue()) {
            return;
        }
        const realIndex = (() => {
            if (index < 0) {
                return this.numberOfSlides$.getValue() - 1;
            }
            if (index >= this.numberOfSlides$.getValue()) {
                return 0;
            }
            return index;
        })();
        const scrollableContainer = this.el.nativeElement.querySelector('.scrollable-container');
        if (scrollableContainer) {
            scrollableContainer.scrollLeft = realIndex * this.containerWidth$.getValue();
        }
        this.setCurrentSlideIndex(realIndex);
        this.queueNextAutoSlide();
    }
    onResize() {
        this.updateContainerWidth();
    }
    ngAfterContentInit() {
        this.updateContainerWidth();
    }
    updateContainerWidth() {
        this.containerWidth$.next(this.getContainerWidth());
    }
    getContainerWidth() {
        if (!this.el.nativeElement.getBoundingClientRect) {
            return 0;
        }
        // We may need to go up nearest parent that has width > 0
        return this.el.nativeElement.getBoundingClientRect().width;
    }
    ngAfterViewInit() {
        this.calculateNumberOfSlides();
    }
    calculateNumberOfSlides() {
        this.numberOfSlides$.next(this.carouselItems.length);
    }
    queueNextAutoSlide() {
        clearTimeout(this.timer);
        if (this.autoSlide) {
            this.timer = setTimeout(() => {
                this.slideNext();
            }, this.slideTimerInMs);
        }
    }
    ngOnDestroy() {
        clearTimeout(this.timer);
    }
}
CarouselComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: CarouselComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
CarouselComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: CarouselComponent, selector: "sm-carousel", inputs: { height: "height", hideNavigationButton: "hideNavigationButton", hideBullets: "hideBullets", autoSlide: "autoSlide", slideTimerInMs: "slideTimerInMs" }, host: { listeners: { "window:resize": "onResize()" }, properties: { "style.--carousel-height": "this.carouselHeight" } }, queries: [{ propertyName: "carouselItems", predicate: CarouselItemComponent }], ngImport: i0, template: "<div class=\"scrollable-container\" style.--carousel-width=\"{{containerWidth$ | async}}px\" (scroll)=\"onScroll($event)\"  (touchstart)=\"onTouchDown()\" (touchend)=\"onTouchUp()\">\n  <div class=\"items-container\">\n    <ng-content></ng-content>\n  </div>\n</div>\n<div class=\"prev\" (click)=\"slidePrevious()\" *ngIf=\"showPreviousButton$ | async\">&#8249;</div>\n<div class=\"next\" (click)=\"slideNext()\" *ngIf=\"showNextButton$ | async\">&#8250;</div>\n<ng-container *ngIf=\"!hideBullets\">\n  <div class=\"bullets\" *ngIf=\"bulletArray$ | async as bulletArray\">\n    <div class=\"bullet\" *ngFor=\"let bullet of bulletArray; let i = index\" [class.selected]=\"bullet\" (click)=\"slideToIndex(i)\"></div>\n  </div>\n</ng-container>\n", styles: [":host{touch-action:pan-y;position:relative;display:block}@media (hover: hover){:host:hover .prev,:host:hover .next{z-index:auto;opacity:.5;transition:opacity .2s linear}:host:hover .prev:hover,:host:hover .next:hover{opacity:1}}.scrollable-container{scroll-snap-type:x mandatory;overflow-x:auto;overflow-y:hidden;display:flex;scroll-behavior:smooth;scrollbar-width:none}.scrollable-container::-webkit-scrollbar{display:none}.prev,.next{position:absolute;top:0;width:100px;cursor:pointer;z-index:-1;opacity:0;-webkit-user-select:none;user-select:none;text-align:center;color:#ffffffb3;font-size:135px;bottom:0;display:flex;align-items:center;justify-content:center}.prev{left:0}.next{right:0}.items-container{display:flex;align-items:center}.bullets{position:absolute;left:0;right:0;bottom:10px;display:flex;gap:5px;justify-content:center}.bullet{height:5px;width:10px;border-radius:3px;background-color:#fff3;cursor:pointer;transition:background-color 3s linear}.bullet.selected{border:0;background-color:#ffffff80}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: CarouselComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sm-carousel', template: "<div class=\"scrollable-container\" style.--carousel-width=\"{{containerWidth$ | async}}px\" (scroll)=\"onScroll($event)\"  (touchstart)=\"onTouchDown()\" (touchend)=\"onTouchUp()\">\n  <div class=\"items-container\">\n    <ng-content></ng-content>\n  </div>\n</div>\n<div class=\"prev\" (click)=\"slidePrevious()\" *ngIf=\"showPreviousButton$ | async\">&#8249;</div>\n<div class=\"next\" (click)=\"slideNext()\" *ngIf=\"showNextButton$ | async\">&#8250;</div>\n<ng-container *ngIf=\"!hideBullets\">\n  <div class=\"bullets\" *ngIf=\"bulletArray$ | async as bulletArray\">\n    <div class=\"bullet\" *ngFor=\"let bullet of bulletArray; let i = index\" [class.selected]=\"bullet\" (click)=\"slideToIndex(i)\"></div>\n  </div>\n</ng-container>\n", styles: [":host{touch-action:pan-y;position:relative;display:block}@media (hover: hover){:host:hover .prev,:host:hover .next{z-index:auto;opacity:.5;transition:opacity .2s linear}:host:hover .prev:hover,:host:hover .next:hover{opacity:1}}.scrollable-container{scroll-snap-type:x mandatory;overflow-x:auto;overflow-y:hidden;display:flex;scroll-behavior:smooth;scrollbar-width:none}.scrollable-container::-webkit-scrollbar{display:none}.prev,.next{position:absolute;top:0;width:100px;cursor:pointer;z-index:-1;opacity:0;-webkit-user-select:none;user-select:none;text-align:center;color:#ffffffb3;font-size:135px;bottom:0;display:flex;align-items:center;justify-content:center}.prev{left:0}.next{right:0}.items-container{display:flex;align-items:center}.bullets{position:absolute;left:0;right:0;bottom:10px;display:flex;gap:5px;justify-content:center}.bullet{height:5px;width:10px;border-radius:3px;background-color:#fff3;cursor:pointer;transition:background-color 3s linear}.bullet.selected{border:0;background-color:#ffffff80}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { height: [{
                type: Input
            }], hideNavigationButton: [{
                type: Input
            }], hideBullets: [{
                type: Input
            }], autoSlide: [{
                type: Input
            }], slideTimerInMs: [{
                type: Input
            }], carouselItems: [{
                type: ContentChildren,
                args: [CarouselItemComponent]
            }], carouselHeight: [{
                type: HostBinding,
                args: ['style.--carousel-height']
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

class CarouselModule {
}
CarouselModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: CarouselModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CarouselModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: CarouselModule, declarations: [CarouselComponent, CarouselItemComponent], imports: [CommonModule], exports: [CarouselComponent, CarouselItemComponent] });
CarouselModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: CarouselModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: CarouselModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CarouselComponent, CarouselItemComponent],
                    imports: [CommonModule],
                    exports: [CarouselComponent, CarouselItemComponent],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CarouselComponent, CarouselItemComponent, CarouselModule };
